import {STEP_MODEL} from "../Model/Model";
import Steps from "./Steps";
/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const StepContainer = ({stepModel, activeStep, t, loading ,getInvitationById,data,handleChange,
                           emptyFields,StepLoading,photoPickerList, setPhotoPickerList, handleDeletePhotoPicker,
                           isValidData}) => {

    const { renderCompleteSteps } = Steps(
        {
            activeStep,
            t,
            loading,
            getInvitationById,
            data,
            handleChange,
            emptyFields,
            StepLoading,
            photoPickerList,
            setPhotoPickerList,
            handleDeletePhotoPicker,
            isValidData
        });


    const renderStepContent = () => {
        switch (stepModel?.NAME) {
            case STEP_MODEL.COMPLETE.NAME:
                return renderCompleteSteps();
            default:
                return null;
        }
    };

    return <>{renderStepContent()}</>;
};

export default StepContainer
